import { CustomerConfig } from './types'

const config: CustomerConfig = {
  entraClientId: '9736c6ec-cf83-4a7b-84cd-d9e3b997545d',
  header: 'Helsebiblioteket - pediatri',
  headerLogoUrl: {
    light: '/logos/HB_logo.svg',
    dark: '/logos/HB_logo_dark.svg',
  },
  subheader: '',
  version: 'Alfa 1.0',
  logo: 'semantic_lab_logo_hvit.png',
  theme: {
    isLight: true,
    bgColor: 'bg-gray-800',
    textColor: 'text-fancy-wood',
    bubbles: 'gray-800',
  },
  chatServer:
    (process.env.REACT_APP_CHAT_SERVER || 'https://ai.semanticlab.no') +
    '/api/v1/chatbots/koble',
}
export default config
